export default __webpack_public_path__ + "static/media/ring.49df254f.wav";